export default __webpack_public_path__ + "static/media/hero-laptop-icon.380e836e.svg";